module.exports = require("npm:process-nextick-args@1.0.6/index.js");